// components/FullscreenGraceDialog.tsx
import React from 'react';

interface FullscreenGraceDialogProps {
  countdown: number;
  onReEnterFullscreen: () => void;
}

export const FullscreenGraceDialog: React.FC<FullscreenGraceDialogProps> = ({ countdown, onReEnterFullscreen }) => {
  return (
    <div className="fixed inset-0 bg-black/70 z-50 flex items-center justify-center" aria-modal="true">
      <div className="bg-brand-surface rounded-lg shadow-xl p-6 w-full max-w-md text-center">
        <h2 className="text-2xl font-bold text-red-500">Warning!</h2>
        <p className="text-brand-text-secondary mt-4">
          You have exited fullscreen mode. The test will be automatically submitted if you do not return to fullscreen.
        </p>
        <div className="my-6">
          <p className="text-lg font-bold">Submitting in:</p>
          <p className="text-5xl font-mono font-bold text-brand-primary">{countdown}</p>
        </div>
        <button 
          onClick={onReEnterFullscreen} 
          className="w-full px-8 py-3 text-base font-semibold text-white bg-brand-primary rounded-lg hover:bg-brand-primary-hover transition-colors shadow-sm"
        >
          Re-enter Fullscreen
        </button>
      </div>
    </div>
  );
};
